import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login'
import ChangePassword from '../views/ChangePassword'
import Dashboard from '../views/Dashboard'
import CustomerList from '../views/customer/CustomerList'
import HardwareList from '../views/hardware/HardwareList'
import AdminList from '../views/admin/AdminList'
import AnnouncementList from '../views/announcement/AnnouncementList.vue'
import FirmwareList from '../views/firmware/FirmwareList'
import CustomerDetails from '../views/customer/CustomerDetails'
import CustomerAdminList from '../views/customer/CustomerAdminList'
import CustomerFeatureList from '../views/customer/CustomerFeatureList'
import CustomerUsageReportSummary from '../views/customer/CustomerUsageReportSummary'
import CustomerUse from '../views/customer/CustomerUse'
import CustomerWebhook from '../views/customer/CustomerWebhook'
import NotFound from '../views/NotFound'
import NetworkIssue from '../views/NetworkIssue'
import Maintenance from '../views/Maintenance'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer',
    name: 'CustomerList',
    component: CustomerList,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/details',
    name: 'CustomerDetails',
    component: CustomerDetails,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/use',
    name: 'CustomerUse',
    component: CustomerUse,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/admin',
    name: 'CustomerAdminList',
    component: CustomerAdminList,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/feature',
    name: 'CustomerFeatureList',
    component: CustomerFeatureList,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/usage-summary',
    name: 'CustomerUsageReportSummary',
    component: CustomerUsageReportSummary,
    meta: { requiresAuth: true },
  },
  {
    path: '/customer/:uuid/webhook',
    name: 'CustomerWebhook',
    component: CustomerWebhook,
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware',
    name: 'HardwareList',
    component: HardwareList,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    name: 'AdminList',
    component: AdminList,
    meta: { requiresAuth: true },
  },
  {
    path: '/announcement',
    name: 'AnnouncementList',
    component: AnnouncementList,
    meta: { requiresAuth: true },
  },
  {
    path: '/firmware',
    name: 'FirmwareList',
    component: FirmwareList,
    meta: { requiresAuth: true },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/network-issue',
    name: 'NetworkIssue',
    component: NetworkIssue,
    props: true,
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
  },
  {
    path: '*',
    redirect: { name: 'NotFound' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('current_user')

  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next()
    return
  }

  if (loggedIn) {
    next()
  } else {
    next({ name: 'Login' })
  }
})

export default router
